// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-MyAccount-styles___accountLayout--9S7cA {
  text-align: left;
  display: flex;
  flex-direction: column;
}

  @media only screen and (min-width: 1024px) {.pages-MyAccount-styles___accountLayout--9S7cA {
    flex-direction: row
}
  }

  .pages-MyAccount-styles___accountLayout--9S7cA .pages-MyAccount-styles___form--aYHSm {
    max-width: 736px;
    width: 100%;
    padding: 32px;
    margin: 0 0 32px;
  }

  .pages-MyAccount-styles___accountLayout--9S7cA .pages-MyAccount-styles___form--aYHSm .pages-MyAccount-styles___buttonContainer--r3dc4 {
      text-align: right;
    }

  .pages-MyAccount-styles___accountLayout--9S7cA .pages-MyAccount-styles___form--aYHSm .pages-MyAccount-styles___buttonContainer--r3dc4 .pages-MyAccount-styles___button--PKm9p {
        text-transform: initial;
        font-size: 13px;
        height: 34px;
        width: 97px;
        padding: 0;
      }

  .pages-MyAccount-styles___accountLayout--9S7cA .pages-MyAccount-styles___actions--DSgwW {
    padding: 30px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .pages-MyAccount-styles___accountLayout--9S7cA .pages-MyAccount-styles___actions--DSgwW .pages-MyAccount-styles___link--WGEll {
      color: #318afb;
      font-size: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

  .pages-MyAccount-styles___accountLayout--9S7cA .pages-MyAccount-styles___actions--DSgwW .pages-MyAccount-styles___link--WGEll svg {
        margin-right: 8px;
      }

.pages-MyAccount-styles___inputContainer--KHkPy {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 24px;
  border-bottom: 1px solid #dddee0;
}

.pages-MyAccount-styles___inputWrapper--XLzW9 {
  flex: 49% 0 1;
  padding: 8px 0 0;
}
`, "",{"version":3,"sources":["webpack://./pages/MyAccount/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AA2CxB;;EAzCE,4CALF;IAMI;AAwCJ;EAvCE;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gBAAgB;EAalB;;EAXE;MACE,iBAAiB;IASnB;;EAPE;QACE,uBAAuB;QACvB,eAAe;QACf,YAAY;QACZ,WAAW;QACX,UAAU;MACZ;;EAIJ;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAahC;;EAXE;MACE,cAAc;MACd,eAAe;MACf,eAAe;MACf,aAAa;MACb,mBAAmB;IAKrB;;EAHE;QACE,iBAAiB;MACnB;;AAKN;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".accountLayout {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n\n  @media only screen and (min-width: 1024px) {\n    flex-direction: row;\n  }\n\n  .form {\n    max-width: 736px;\n    width: 100%;\n    padding: 32px;\n    margin: 0 0 32px;\n\n    .buttonContainer {\n      text-align: right;\n\n      .button {\n        text-transform: initial;\n        font-size: 13px;\n        height: 34px;\n        width: 97px;\n        padding: 0;\n      }\n    }\n  }\n\n  .actions {\n    padding: 30px 0 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .link {\n      color: #318afb;\n      font-size: 13px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n\n      svg {\n        margin-right: 8px;\n      }\n    }\n  }\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #dddee0;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountLayout": `pages-MyAccount-styles___accountLayout--9S7cA`,
	"form": `pages-MyAccount-styles___form--aYHSm`,
	"buttonContainer": `pages-MyAccount-styles___buttonContainer--r3dc4`,
	"button": `pages-MyAccount-styles___button--PKm9p`,
	"actions": `pages-MyAccount-styles___actions--DSgwW`,
	"link": `pages-MyAccount-styles___link--WGEll`,
	"inputContainer": `pages-MyAccount-styles___inputContainer--KHkPy`,
	"inputWrapper": `pages-MyAccount-styles___inputWrapper--XLzW9`
};
module.exports = ___CSS_LOADER_EXPORT___;
